export default __webpack_public_path__ + "static/media/player_joins.2d60ecf6.mp3";